<template style="height:100%">
  <div class="Scblock">
      <div class="acc">
        <el-row>
          <el-button type="primary" @click="gou_url">开始测试</el-button>
          <!-- <el-button type="primary" plain>发布套餐</el-button> -->
          <!-- <span style="margin-left: 20px;">已选中{{numbers}}条</span> -->


          <el-button class="search_btn" @click="sousuo" type="primary">搜索</el-button>
          <el-input class="search" v-model="Tiaojian"   placeholder="搜索功能关键字" prefix-icon="el-icon-search">
          </el-input>
        </el-row>
      </div>
      <div class="Scblock_ts">
          <h2>量表分类</h2>
          <h3>量表列表</h3>
      </div>
      <el-tabs  :tab-position="tabPosition" style="height: 100%;text-align: left!important; ">
        <el-tab-pane v-for="item in scalelist" :key="item.message" :label="item.PaperName">
          <div class="Scblock_ts_s">
            <h2>选择</h2>
            <h3>量表名称</h3>
            <h4>量表描述</h4>
          </div>
          <ul class="dvdvvd" style="margin-top: 20px;">
            <li v-for="(item,index) in item.LiPaper " :key="index">
              <div class="SCL">
                <el-checkbox-group v-model="checkList" size="small"  @change="setMealSelect">
                  <el-checkbox    :label="item.PaperCode"  :name="item.PaperName">{{item.PaperName}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe" :title="item.Introduction">
                {{item.Introduction}}
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        checkList: [],//只能选中一个的数组
        tabPosition: 'left',
        scalelist:'',
        Tiaojian:'',
        jsonArray:[],
        checkboxGroup1: [],
        checkboxGroup2: [],
        numbers:'0',
      };
    },
    beforeCreate () {
      this.$Http_Post('ScaleIssue/GetShowScale',{"Tiaojian":''}
        ).then(res=>{
          if(res.Code == 200 || res.Code == 0){
            this.scalelist = res.Data;
          }
        })
    },
    methods: {
      setMealSelect() {
        // 截取数组的最后一位,并从新赋值
        this.checkList = this.checkList.slice(-1)
        },
        gou_url(){
          if (this.checkList[0] === 'WAIS-RC_KJ') {
            this.$router.push({
              path: '/measurement/PaperTest_WebsterSpeech',
              query: { PaperID: this.checkList[0], PublishID:"0" },
            })
          } else if (this.checkList[0] === 'WMS') {
            this.$router.push({
              path: '/measurement/PaperTest_WebsterMemory',
              query: { PaperID: this.checkList[0], PublishID:"0" },
            })
          } else {
            this.$router.push({
              path: '/measurement/PaperTest',
              query: { PaperID: this.checkList[0], PublishID: "0"},
            })
          }


        },
      // checkedAllFun(string,number,boolean){//原来选中后新增量表默认选中当前选中的量表
      //   if(string){
      //     var uncs ={}
      //     uncs.name  = number.target.name;
      //     uncs.code  = number.target.value;
      //     this.jsonArray.push(uncs);
      //   }else{
      //     var ss = this.jsonArray;
      //     var i = 0;
      //       for (i = 0; i < ss.length; i++) { 
      //           if (ss[i].name == number.target.name){
      //             ss.splice(i,1)
      //           }
      //       }
      //     this.jsonArray = ss;
      //   }
      //   this.numbers = this.jsonArray.length;
      // },
      sousuo(){
        this.$Http_Post('ScaleIssue/GetShowScale',{"Tiaojian":this.Tiaojian}
        ).then(res=>{
          if(res.Code == 200 || res.Code == 0){
            this.scalelist = res.Data;
          }
        })
      },
      // addpackage(){//原来选中后新增量表默认选中当前选中的量表
      //   if(this.checkboxGroup1.length>=1){
      //     sessionStorage.setItem("checkboxGroup1", this.checkboxGroup1);
      //     sessionStorage.setItem("jsonArray", JSON.stringify(this.jsonArray));
      //     this.$router.push({
      //       path: 'addpackage',
      //       query: {param: "m"}
      //     });
      //   }else{
      //     this.$router.push({
      //       path: 'addpackage',
      //       query: {param: "s"}
      //     });
      //     sessionStorage.setItem("checkboxGroup1", "");
      //     sessionStorage.setItem("jsonArray","");

      //   }
        
      // },
    }
  };
</script>
<style>
  .Scblock>ul{position: relative;min-height: 650px;background-color: chocolate;height: 100%;}
  .Scblock>ul>li{height: 50px;line-height: 50px;color: rgba(61, 61, 61, 1);cursor:pointer;}
  .Scblock>ul>li>ul>li{background-color: chartreuse;width: 90%;min-height: 650px;position: absolute;top: 0px;right: 0px;position: relative;}
  .is-left{text-align: left;}
  .Scblock .el-tabs--left .el-tabs__item.is-left {text-align: left!important;font-size: 14px;}
  .Scblock_ts{width: 100%;height: 40px;line-height: 40px;}
  .Scblock_ts h2{width: 160px;display: inline-block;font-size: 16px;}
  .Scblock_ts h3{width: 160px;display: inline-block;font-size: 16px;}
  .Scblock_ts_s  h2{width: 40px;display: inline-block;font-size: 16px;margin-left: 28px;}
  .Scblock_ts_s  h3{width: 230px;display: inline-block;font-size: 16px;}
  .Scblock_ts_s  h4{width: 130px;display: inline-block;font-size: 16px;}
  .describe{    padding: 20px 32px;border-left: #e3e3e3 1px solid;display: inline-block;max-width: 60%;line-height: 30px;margin-left: 300px;color: rgba(112, 112, 112, 1);overflow: hidden;
/* text-overflow: ellipsis; */
display: -webkit-box;
-webkit-line-clamp: 2;
line-clamp: 2;
-webkit-box-orient: vertical;height: 40px;}


  .dvdvvd li{position: relative;}
  .SCL{margin-top: 20px;margin-left: 11px;width:300px;display: inline-block;position: absolute;top: 20px;left: 20px;}
  .el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__nav-wrap.is-left::after {
    right: 0px;
    left: 0px;
}
.Scblock .el-input{width: 20%;float: right;margin-right: 10px;}
.Scblock .search_btn{float: right;}
.acc{margin-bottom: 20px;}
</style>